import { useSyncExternalStore } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

function subscribe(onChange: () => void): () => void {
  const mq = window.matchMedia?.(QUERY);
  if (!mq) return () => {};
  mq.addEventListener("change", onChange);
  return () => mq.removeEventListener("change", onChange);
}

function getSnapshot(): boolean {
  return window.matchMedia?.(QUERY).matches === true;
}

/**
 * Whether the viewer has asked their OS to reduce motion.
 *
 * index.css already honours the preference for CSS animations, but Niva's
 * avatar and her intro clip are `<video>` elements — a looping face and a
 * 20-second autoplay are exactly the kind of unrequested movement the setting
 * exists to stop, and no stylesheet rule can pause them. Callers fall back to
 * the still poster frame when this is true.
 *
 * Subscribed rather than read once: the setting can be toggled while the tab
 * is open, and on macOS it flips with Reduce Motion in System Settings.
 * useSyncExternalStore is the right shape for that — an effect that seeded
 * state from the query would just be a cascading render.
 */
export function usePrefersReducedMotion(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}

export default usePrefersReducedMotion;
